import React from "react";
import "./OurService.css"; // import the CSS file
import RadialInfo from '../components/RadialInfo';
import Carousel  from "../components/Carousel";
import { Link } from "react-router-dom";  
const services = [
  {
    id: 1,
    title: 'Water Treatment plant (WTP)',
    description:
      'A water treatment plant is a facility designed to purify and process raw water, removing contaminants and harmful substances to make it safe for drinking, industrial use, or environmental discharge. Through processes like filtration, sedimentation, and disinfection, these plants ensure clean, reliable water supply while protecting public health and ecosystems.',
    image: '/images/WTP.jpeg',
    alt: 'WTP',
  },
  {
    id: 2,
    title: 'Sewage Treatment Plant (STP)',
    description:
      'Our sewage treatment solutions are designed to safely process wastewater from residential, commercial, and industrial sources. Using advanced biological and mechanical systems, we remove pollutants and harmful substances, ensuring the treated water meets environmental standards. The result is cleaner water that can be safely discharged or reused, helping communities protect public health and preserve natural ecosystems.',
    image: '/images/STP.png',
    alt: 'STP',
  },
  {
    id: 3,
    title: 'Effluent Treatment Plant (ETP)',
    description:
      'Our effluent treatment solutions are engineered to handle industrial wastewater, removing toxic chemicals, heavy metals, and organic matter before safe discharge or reuse. Through processes such as neutralization, biological treatment, filtration, and advanced polishing, we ensure compliance with environmental standards while reducing ecological impact.',
    image: '/images/ETP.png',
    alt: 'ETP',
  },
  {
    id: 4,
    title: 'Ultra Filtration (UF)',
    description:
      'Our ultra filtration systems provide advanced membrane-based purification, removing suspended solids, bacteria, and high-molecular-weight impurities from water. With precision-engineered membranes, UF delivers consistent clarity and quality, making it ideal for drinking water, industrial processes, and pre-treatment for reverse osmosis.',
    image: '/images/UF.png',
    alt: 'UF',
  },
   {
    id: 5,
    title: 'Reverse Osmosis (RO)',
    description:
      'Our reverse osmosis systems deliver high-purity water by forcing raw water through semi-permeable membranes that remove dissolved salts, minerals, and contaminants. Designed for both industrial and commercial applications, RO ensures consistent water quality, reduced scaling, and improved efficiency across processes.',
    image: '/images/RO.png',
    alt: 'RO',
  },
];

export default function ServicesPage() {
  return (
    <div className="page">
      {/* Hero Section */}
      <section className="hero-service" style={{ backgroundImage: "url('/images/ws.png')",
    backgroundSize: "cover",
    backgroundPosition: "center" }}>
       <div className="hero-service-overlay">
         <h1>Comprehensive Water Treatment Solutions</h1>
        <p>From purification to industrial-scale systems, we deliver sustainable water solutions.</p>
       <Link to="/contact"> <button>Request a Consultation</button></Link>  
       </div>
      </section>

 {/* Radial Infographic Hub */}

      <RadialInfo/>

      {/* Services Grid */}
       <section className="services-alt">
      {services.map((s, index) => (
        <div
          className={`service-row ${index % 2 === 0 ? 'normal' : 'reverse'}`}
          key={s.id}
        >
          <div className="service-image">
            <img src={s.image} alt={s.alt} loading="lazy" />
          </div>
          <div className="service-text">
            <h3>{s.title}</h3>
            <p>{s.description}</p>
            
          </div>
        </div>
      ))}
    </section>

      {/* Client List */}
      <section className="clients">
      <h2 className="clients-heading">Trusted By Leading Brands</h2>
      <div className="clients-logos">
        <Carousel />
      </div>
    </section>

      {/* CTA Section */}
      <section className="cta-abstract">
      <div className="cta-overlay">
        <div className="cta-content">
          <h2>Partner With Us for Sustainable Water Solutions</h2>
          <p>
             From purification to industrial-scale systems, we deliver reliable, eco-friendly water treatment.
          </p>
          <div className="cta-buttons">
            <a href="/contact" className="cta-btn quote">Request a Free Consultation</a>
          </div>
        </div>
      </div>
    </section>

    </div>
  );
}